import { Component, OnDestroy } from '@angular/core';
import { AuditPage } from '@app/forms/subscription/definition/interface/audit-page';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { AUDIT_PAGE_LABELS } from '../audit-pages';

@Component({
  selector: 'ea-audit-page-choice-modal',
  templateUrl: './audit-page-choice-modal.component.html',
  styleUrls: ['./audit-page-choice-modal.component.scss'],
  standalone: false,
})
export class AuditPageChoiceModalComponent implements OnDestroy {
  readonly choice = new Subject<AuditPage>();
  readonly labels = AUDIT_PAGE_LABELS;
  pages: AuditPage[] = [];
  selected: AuditPage;

  constructor(public modalRef: BsModalRef) {}

  confirm() {
    this.choice.next(this.selected);
    this.modalRef.hide();
  }

  cancel() {
    this.modalRef.hide();
  }

  ngOnDestroy() {
    this.choice.complete();
  }
}
